import { Swiper, Navigation } from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

class SliderCards {
  constructor() {
    // eslint-disable-next-line no-unused-expressions
    this.resizeTimer;
    this.swipers = new Map();
    this.sliderCards = document.querySelectorAll('.slider-cards');
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.checkAndInitSwiper();
      this.calculateOffsets();
      this.bindCardReveal();
    });

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.checkAndInitSwiper();
        this.calculateOffsets();
        this.bindCardReveal();
      }, 250);
    });
  }

  bindCardReveal() {
    const REVEALED_CLASS = 'slider-cards__room-card--revealed';

    const isTablet = () => {
      const width = window.innerWidth;
      // eslint-disable-next-line no-undef
      return width >= breakpoints.tablet && width <= breakpoints.desktop;
    };

    const removeRevealed = (slider) => {
      slider?.querySelectorAll(`.${REVEALED_CLASS}`).forEach((el) => el.classList.remove(REVEALED_CLASS));
    };

    this.sliderCards?.forEach((slider) => {
      const cards = slider.querySelectorAll('.slider-cards__room-card');
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (!isTablet()) return;
          if (e.target.closest('.slider-cards__room-card-link')) return;

          e.preventDefault();
          const content = card.querySelector('.slider-cards__room-card-content');
          if (!content) return;

          if (card.classList.contains(REVEALED_CLASS)) {
            card.classList.remove(REVEALED_CLASS);
          } else {
            removeRevealed(slider);
            card.classList.add(REVEALED_CLASS);
          }
        });
      });

      document.addEventListener('click', (e) => {
        if (!isTablet()) return;
        const clickedCard = e.target.closest('.slider-cards__room-card');
        // Only skip closing when click is on a card of THIS slider (card handler will toggle)
        if (clickedCard && slider.contains(clickedCard)) return;
        removeRevealed(slider);
      });
    });
  }

  calculateOffsets() {
    this.descriptionObserver?.disconnect();
    this.descriptionObserver = new ResizeObserver((entries) => {
      entries.forEach(({ target, borderBoxSize }) => {
        this.setCardOffset(target, borderBoxSize?.[0]?.blockSize ?? target.clientHeight);
      });
    });

    this.sliderCards?.forEach((slider) => {
      slider.querySelectorAll('.slider-cards__room-card-description-wrap').forEach((cardDescription) => {
        this.descriptionObserver.observe(cardDescription);
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  setCardOffset(cardDescription, height) {
    // eslint-disable-next-line no-undef
    if (window.innerWidth < breakpoints.mobile) {
      return;
    }

    const cardContent = cardDescription.closest('.slider-cards__room-card-content');
    if (!cardContent) return;

    cardContent.style.bottom = `-${height}px`;
    cardContent.dataset.bottomOffset = height;
  }

  checkAndInitSwiper() {
    this.sliderCards?.forEach((slider) => {
      const container = slider.querySelector('.slider-cards__swiper');
      const slides = container?.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');

      if (!container || !slides || slides.length <= 1) {
        this.destroySwiper(slider);
        return;
      }

      const slideCount = slides.length;
      const windowWidth = window.innerWidth;
      const shouldInit = (slideCount > 3 && windowWidth >= 1200)
                        || (slideCount > 1 && windowWidth < 1200);

      if (shouldInit) {
        if (!this.swipers.has(slider)) {
          this.initSwiper(slider);
        } else {
          const swiper = this.swipers.get(slider);
          if (swiper && typeof swiper.update === 'function') {
            swiper.update();
            swiper.updateSize();
            swiper.updateSlides();
          }
        }
      } else {
        this.destroySwiper(slider);
      }
    });
  }

  initSwiper(slider) {
    const container = slider.querySelector('.slider-cards__swiper');
    const prevBtn = slider.querySelector('.slider-cards__nav--prev');
    const nextBtn = slider.querySelector('.slider-cards__nav--next');
    const slides = container?.querySelectorAll('.swiper-slide');

    if (!container || !slides || slides.length <= 1) {
      return;
    }

    if (this.swipers.has(slider)) {
      this.destroySwiper(slider);
    }

    const swiper = new Swiper(container, {
      modules: [Navigation, HideOffscreenSlides],
      loop: true,
      watchOverflow: true,
      slidesPerView: 3,
      spaceBetween: 24,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });

    this.swipers.set(slider, swiper);

    slider.querySelector('.slider-cards__wrapper')?.classList.remove('slider-cards__wrapper--list');
    slider.querySelectorAll('.swiper-slide')?.forEach((slide) => {
      slide.classList.remove('swiper-slide--list-item');
    });

    const navs = slider.querySelector('.slider-cards__navs');
    navs.style.display = 'flex';
  }

  destroySwiper(slider) {
    const navs = slider.querySelector('.slider-cards__navs');
    navs.style.display = 'none';

    if (this.swipers.has(slider)) {
      const swiper = this.swipers.get(slider);
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true); // destroy: true, cleanStyles: true
      }
      this.swipers.delete(slider);
    }

    slider.querySelector('.slider-cards__wrapper')?.classList.add('slider-cards__wrapper--list');
    slider.querySelectorAll('.swiper-slide')?.forEach((slide) => {
      slide.classList.add('swiper-slide--list-item');
    });
  }
}

const SliderCardsObj = new SliderCards();
SliderCardsObj.init();
